import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGameConfig } from '../../context/GameConfigContext';

const WikiEfsunPanel = ({ profiles, loading }) => {
  const { t } = useTranslation('wiki');
  const { gelistirmeConsole: showChances } = useGameConfig();

  if (loading) return <p>{t('loading')}</p>;
  if (!profiles?.length) return <p className="wiki-empty">{t('loadError')}</p>;

  return (
    <div className="wiki-efsun-panels">
      {profiles.map((profile) => (
        <div key={profile.profileName} className="wiki-efsun-panel">
          <h3>{profile.profileName}</h3>

          {showChances && (
          <div className="wiki-efsun-tier-bar">
            <strong>{t('efsunTierPercents')}:</strong>
            {profile.tierPercents?.map((tp) => (
              <span key={tp.tier} className="wiki-tier-chip">
                {t('efsunTierChance', { tier: tp.tier, percent: tp.percent?.toFixed(1) })}
              </span>
            ))}
          </div>
          )}

          <div className="wiki-efsun-table-wrap">
            <table className="wiki-efsun-table">
              <thead>
                <tr>
                  <th>{t('efsunType')}</th>
                  <th>{t('efsunValues')}</th>
                  {showChances && <th>{t('efsunTypeChance', { percent: profile.types?.[0]?.typeChancePercent?.toFixed(1) ?? '0' })}</th>}
                </tr>
              </thead>
              <tbody>
                {profile.types?.map((etype) => (
                  <tr key={etype.typeKey}>
                    <td>
                      {etype.label}
                      {etype.percent ? ' (%)' : ''}
                      {etype.signed ? ' ±' : ''}
                    </td>
                    <td>
                      {etype.values?.map((v, i) => (
                        <span key={i} className="wiki-efsun-tier-val">T{i + 1}: {v}{etype.percent ? '%' : ''} </span>
                      ))}
                    </td>
                    {showChances && <td>{etype.typeChancePercent?.toFixed(1)}%</td>}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WikiEfsunPanel;
